import adaptDateTimeFormat from './_adapt-date-time-format';

const adaptDateTimeParameter = (value) => (value ? adaptDateTimeFormat(value).replace('+', encodeURI('+')).slice(0, -3) : '');

export default adaptDateTimeParameter;
